export function getCurrentToken() {
    const token = localStorage.getItem("authToken");

    if (token) {
        return token;
    } else {
        return "";
    }
}